// extracted by mini-css-extract-plugin
export default {"FormSelectMultiple":"FormSelectMultiple","Select":"Select","Button--select":"Button--select","Button-dropdown":"Button-dropdown"};